import Vue from 'vue';
import VIcon from 'vuetify/lib/components/VIcon';
import VTooltip from 'vuetify/lib/components/VTooltip';
import VBtn from 'vuetify/lib/components/VBtn';
import { DESCRIPTIONS } from '../../global';

Vue.component('v-icon', VIcon);
Vue.component('v-tooltip', VTooltip);
Vue.component('v-btn', VBtn);

export default Vue.extend({
  template: `
    <v-tooltip v-model="tooltip" bottom max-width="350" content-class="tooltip">
      <template v-slot:activator="{ on }">
        <div class="grid-header" v-on="on">
          <v-btn icon small color="primary" @click="toggleSort($event)">
            <v-icon small>{{sortIcon}}</v-icon>
          </v-btn>
          
          <div class="grid-header-text">{{params.displayName}}</div> 
                
          <div ref="menuButton">
            <v-btn icon small @click="toggleMenu" color="primary">
              <v-icon small>mdi-filter</v-icon>
            </v-btn>
          </div>
        </div>
      </template>
      <div>
        <div class="text-center font-weight-bold">{{params.displayName + (sortOrder !== '' ? ' | ' + sortOrder.toUpperCase() : '')}}</div>
        <div v-html="getDescription()"></div>
      </div>
    </v-tooltip>
  `,
  data() {
    return {
      sortOrder: '',
      sortIcon: 'mdi-sort',
      tooltip: false
    };
  },
  mounted() {
    this.params.column.addEventListener('sortChanged', this.getSortState);
    this.getSortState();
  },
  methods: {
    toggleMenu() {
      this.tooltip = false;
      this.params.showColumnMenu(this.$refs.menuButton);
    },

    setSortState(order) {
      switch (order) {
        case 'asc':
          this.sortOrder = 'asc';
          this.sortIcon = 'mdi-sort-ascending';
          break;
        case 'desc':
          this.sortOrder = 'desc';
          this.sortIcon = 'mdi-sort-descending';
          break;
        default:
          this.sortOrder = '';
          this.sortIcon = 'mdi-sort'
      }
    },

    getSortState() {
      if (this.params.column.isSortAscending()) {
        this.setSortState('asc');
      } else if (this.params.column.isSortDescending()) {
        this.setSortState('desc');
      } else {
        this.setSortState('');
      }
    },

    getDescription() {
      const description = DESCRIPTIONS.find(d => d.id === this.params.column.colId);
      return description ? description.body : 'No description available.';
    },

    toggleSort(event) {
      switch (this.sortOrder) {
        case 'asc':
          this.setSortState('desc');
          break;
        case 'desc':
          this.setSortState('');
          break;
        default:
          this.setSortState('asc');
      }

      this.params.setSort(this.sortOrder, event.shiftKey);
    }
  }
});